import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import { CheckoutAccordion, CheckoutAccordionActions, Tooltip } from 'shared/components';
import Reward from 'checkout/components/sections/rewards/wallet/reward';

export default function RewardsWallet({
  appliedRewards,
  hasEligibleRewards,
  rewardsBalance,
  rewardsProgramDisplayName,
  rewardsType,
  rewardsToShow,
  isDutchiePOSLoyaltyEnabled,
  ...props
}) {
  return (
    <CheckoutAccordion expanded defaultButton={false}>
      <Header>
        <Balance>
          <b>Your balance:</b>
          {` ${parseInt(rewardsBalance ?? 0, 10)} pts`}
        </Balance>
      </Header>
      <CheckoutAccordionActions>
        {hasEligibleRewards ? (
          <div>
            {isDutchiePOSLoyaltyEnabled ? (
              <InfoBox>
                The following rewards options are eligible for this order. Redeem your rewards in store when completing
                your order.
              </InfoBox>
            ) : (
              <Tooltip
                mainCopy={
                  <DescriptionText id='rewardsWalletBody'>
                    {`The following ${rewardsProgramDisplayName?.toLowerCase()} options are eligible for this order`}
                  </DescriptionText>
                }
                // eslint-disable-next-line max-len
                tooltipCopy={`Options earned in ${rewardsType} can be applied to your online order.`}
                bottom='33px'
                right='-35px'
                arrowRight='35px'
                icon={{ src: '/icons/info-icon.svg' }}
              />
            )}
            {_.map(rewardsToShow, (reward) => (
              <Reward
                key={reward.id}
                isRewardApplied={_.some(appliedRewards, ['id', reward.id])}
                reward={reward}
                rewardsType={rewardsType}
                hideApplyButton={isDutchiePOSLoyaltyEnabled}
                {...props}
              />
            ))}
          </div>
        ) : (
          <DescriptionText id='rewardsWalletEmpty'>There are no eligible options in your wallet.</DescriptionText>
        )}
      </CheckoutAccordionActions>
    </CheckoutAccordion>
  );
}

const Header = styled.div`
  background-color: #f3f6f8;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 21px;
  margin-bottom: 24px;
`;

const Balance = styled.div`
  b {
    font-weight: bold;
  }
  font-size: 12px;
  color: #6b6f73;
`;

const DescriptionText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: #6b6f73;
`;

const InfoBox = styled(DescriptionText)`
  background: #f3f9f3;
  border-radius: 4px;
  border: 1px solid #cfe6dc;
  color: #5b8b75;
  padding: 12px 16px;
`;
